import { TCommandInfo, TDialogElement, TIdInfo } from 'components/Projects/ProjectAILARP';
import { action, makeObservable, observable } from 'mobx';
import i18n from 'locales/i18n';
import BaseStore from './BaseStore';
import { RootStore } from './RootStore';

export type TPersonInfo = {
  id: number;
  description: string;
  name: string;
  title: string;
  location: string;
  locationId?: number;
  group: string;
  groupId?: number;
};

class PrototypePersonStore extends BaseStore {
  _ids!: number;
  constructor(rootStore: RootStore) {
    super(rootStore, {
      parseCommands: action,
    });
    this._ids = 0;
    makeObservable(this, {
      _ids: observable,
    });
  }
  get data(): TPersonInfo[] {
    return this._data as TPersonInfo[];
  }

  get ids() {
    this._ids += 1;
    return this._ids;
  }

  parseCommands(commands: TCommandInfo[], newDialog: TDialogElement[]) {
    if (!commands?.length) return;
    commands.forEach((command: TCommandInfo) => {
      if (!command?.command) return;
      switch (command.command) {
        case 'person_add':
          this.add({ ...command.data, id: this.ids } as TPersonInfo);
          newDialog.push({
            text: i18n.t('projectLARPAI.personAdd') + (command.data as TPersonInfo).name,
            source: 'system',
          });
          break;
        case 'person_remove':
          if (command.id) {
            if (Number.isNaN(+command.id)) return;
            const { name } = this.get(+command.id);
            this.remove(+command.id);
            newDialog.push({ text: i18n.t('projectLARPAI.personDelete') + name, source: 'system' });
          }
          break;
        case 'person_edit':
          {
            const { id = 0, data } = command;
            if (Number.isNaN(+id)) return;
            if (id !== undefined && id > -1) {
              this.updateMerge({ ...data, id: +id });
              newDialog.push({
                text: i18n.t('projectLARPAI.personEdit') + this.get(+id).name,
                source: 'system',
              });
            }
          }
          break;
        default:
          break;
      }
    });
  }

  sendToAI(commands: TCommandInfo[]) {
    this._data.forEach((el: TPersonInfo) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data: any = { ...el };
      delete data.id;
      commands.push({
        command: 'person_add',
        id: el.id,
        data,
      });
    });
  }
  getIds(): TIdInfo {
    const list: TIdInfo = {};
    this._data.forEach((el: TPersonInfo) => {
      list[el.name] = el.id;
    });
    return list;
  }
}
export default PrototypePersonStore;
